export const SET_SHOW_CALC_CHEF_PROC_FEE_MODAL =
  'SET_SHOW_CALC_CHEF_PROC_FEE_MODAL'

export const displayCalcChefProcFeeModal = ({ show }) => {
  return {
    type: SET_SHOW_CALC_CHEF_PROC_FEE_MODAL,
    show,
  }
}
